// Partner referral code carried in the app URL (?ref=<code>). The /r/ partner
// link redirect sets no cookie; it only adds ?ref= to the app URL. The code is
// held in page memory and left in the address bar so a refresh keeps it, and
// signup sends it with the request, so same-visit credit needs no cookie.
// Separately, index.tsx writes it to the __ls_ref cookie only once CookieYes
// reports Advertisement consent. The server decides whether the code belongs
// to an active partner; an unknown code credits nobody.
export const REFERRAL_CODE_PARAM = 'ref';
const MAX_REFERRAL_CODE_LENGTH = 64;
const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;
// Returns the referral code in a query string, or '' when it is absent or
// cannot be a partner code.
export const parseReferralCode = (search) => {
    const params = typeof search === 'string' ? new URLSearchParams(search) : search;
    const code = (params.get(REFERRAL_CODE_PARAM) || '').trim();
    if (!code || code.length > MAX_REFERRAL_CODE_LENGTH || !REFERRAL_CODE_PATTERN.test(code)) {
        return '';
    }
    return code;
};
let capturedReferralCode = '';
// Reads the referral code from the URL the page was loaded with. Called once
// at startup, before any route change can drop the query string.
export const captureReferralCode = (search) => {
    capturedReferralCode = parseReferralCode(search);
};
export const getReferralCode = () => capturedReferralCode;
